import { render, staticRenderFns } from "./ReportingmiSimple.vue?vue&type=template&id=638642f6&"
import script from "./ReportingmiSimple.vue?vue&type=script&lang=js&"
export * from "./ReportingmiSimple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports